class BackInStockButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("[data-bis-button]");
    this.button?.addEventListener("click", () => {
      const templateContent = this.querySelector(
        "[data-bis-modal-content]"
      ).content.firstElementChild.cloneNode(true);
      const matchingOption = templateContent.querySelector(
        `[value="${this.getAttribute("selected-variant")}"]`
      );
      if (matchingOption) {
        matchingOption.setAttribute("selected", "");
      }

      const html = templateContent.outerHTML;

      this.button.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { html, target: "bis-modal" },
        })
      );
    });
  }
}

if (!customElements.get("back-in-stock-button")) {
  customElements.define("back-in-stock-button", BackInStockButton);
}
